import { Button } from 'primereact/button';

interface PickListControlsProps {
  canMoveToTarget: boolean;
  canMoveAllToTarget: boolean;
  canMoveToSource: boolean;
  canMoveAllToSource: boolean;
  onMoveToTarget: () => void;
  onMoveAllToTarget: () => void;
  onMoveToSource: () => void;
  onMoveAllToSource: () => void;
}

export function PickListControls({
  canMoveToTarget,
  canMoveAllToTarget,
  canMoveToSource,
  canMoveAllToSource,
  onMoveToTarget,
  onMoveAllToTarget,
  onMoveToSource,
  onMoveAllToSource,
}: PickListControlsProps) {
  return (
    <div className="bmwe-picklist-controls">
      <Button
        icon="pi pi-angle-right"
        onClick={onMoveToTarget}
        disabled={!canMoveToTarget}
        aria-label="Move selected to target"
        outlined
      />
      <Button
        icon="pi pi-angle-double-right"
        onClick={onMoveAllToTarget}
        disabled={!canMoveAllToTarget}
        aria-label="Move all to target"
        outlined
      />
      <Button
        icon="pi pi-angle-left"
        onClick={onMoveToSource}
        disabled={!canMoveToSource}
        aria-label="Move selected to source"
        outlined
      />
      <Button
        icon="pi pi-angle-double-left"
        onClick={onMoveAllToSource}
        disabled={!canMoveAllToSource}
        aria-label="Move all to source"
        outlined
      />
    </div>
  );
}
